import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-file-word-fill",
  "use": "rt-portal-file-word-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-file-word-fill\">\r\n<path d=\"M854.6,288.9c6,6,9.4,14.1,9.4,22.6v616c0,17.7-14.3,32-32,32H192c-17.7,0-32-14.3-32-32V96.5c0-17.7,14.3-32,32-32h424.7\r\n\tc8.5,0,16.7,3.4,22.7,9.4L854.6,288.9L854.6,288.9z M790.2,326.2L602,138.2v188H790.2z M512,566l52.8,196.8\r\n\tc1.4,5.2,6.2,8.9,11.6,8.9h31.8c5.4,0,10.2-3.6,11.6-8.9l74.4-275.7c0.3-1,0.4-2.1,0.4-3.1c0-6.6-5.4-12-12-12H647\r\n\tc-5.6,0-10.4,3.9-11.7,9.3l-45.8,198.9l-49.8-199.1c-1.3-5.3-6.1-9.1-11.6-9.1h-32.2c-5.5,0-10.3,3.7-11.6,9.1l-49.7,198.7\r\n\tl-46.1-198.5c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4c-1.1,0-2.1,0.1-3.1,0.4c-6.4,1.7-10.2,8.3-8.5,14.7L404,762.8\r\n\tc1.4,5.2,6.2,8.9,11.6,8.9h32c5.4,0,10.2-3.6,11.6-8.9L512,566z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/file-word-fill.svg
// module id = 1851
// module chunks = 137